<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { OverflowMenuVertical16 } from '@carbon/icons-vue';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';
import { usePolicy } from 'dashboard/composables/usePolicy';

// "Add contact" left this menu for its own button in the header (fase 5.2).
const emit = defineEmits(['import', 'export']);

const { t } = useI18n();
const { checkPermissions } = usePolicy();

const contactMenuItems = computed(() => [
  ...(checkPermissions(['administrator', 'contact_manage'])
    ? [
        {
          label: t(
            'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'
          ),
          action: 'export',
          value: 'export',
          icon: 'i-lucide-upload',
        },
      ]
    : []),
  ...(checkPermissions(['administrator', 'contact_manage'])
    ? [
        {
          label: t(
            'CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'
          ),
          action: 'import',
          value: 'import',
          icon: 'i-lucide-download',
        },
      ]
    : []),
]);
const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  }
};
</script>

<!-- eslint-disable vue/no-root-v-if -->
<template>
  <div
    v-if="contactMenuItems.length"
    v-on-clickaway="() => (showActionsDropdown = false)"
    class="relative"
  >
    <Button
      variant="ghost"
      size="icon-sm"
      :class="showActionsDropdown ? 'bg-polaris-accent' : ''"
      :aria-label="t('CONTACTS_POLARIS.HEADER.MORE_ACTIONS')"
      :title="t('CONTACTS_POLARIS.HEADER.MORE_ACTIONS')"
      :aria-expanded="showActionsDropdown"
      @click="showActionsDropdown = !showActionsDropdown"
    >
      <OverflowMenuVertical16 aria-hidden="true" />
    </Button>
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleContactAction($event)"
    />
  </div>
</template>
